import styled from '@emotion/styled';

import { Link, useNavigate } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, IconButton, Button, useTheme } from '@mui/material';

import useSimpleTable from '../../../hooks/useSimpleTable';

import SimplePagination from '../../../utils/utilities/SimplePagination';

import TimelineItem from '../../../utils/utilities/TimelineItem';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

import ServiceHistoryCard from '../Components/ServiceHistoryCard';

const Pagination = styled.div`
  margin-top: 5rem;
`

const ServiceHistoryComponent = ({ inventory_id }) => {

  const { data: history, pagination, setPagination } = useSimpleTable({url: `/inventory/service_history/${inventory_id}`, defaultSort: "-created_at"});

  const theme = useTheme();

  return (
    <Card elevation={0}>
      <CardHeader title="Wig Service History" />
      <CardContent>

        {history?.rows?.map((hi, index) => {
          let st = hi.source_type;
          let palette = st === "repair" ? theme.palette.secondary.main : theme.palette.primary.main;
          return (
            <TimelineItem TimelineColor={palette} last={index === history.rows.length - 1}>
              <ServiceHistoryCard sh={hi} color={palette}>

              </ServiceHistoryCard>
            </TimelineItem>
          )
        })}

        <Pagination>
          <SimplePagination 
            rowsPerPage={pagination?.rowsPerPage} 
            currentPage={pagination?.page} 
            setPagination={setPagination} 
            resultCount={history?.count} 
            results={history?.rows} 
          />
        </Pagination>
        
      </CardContent>
    </Card>
  );
};

export default ServiceHistoryComponent;